/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {PickAndClickController} from "@nolimitcity/slot-game/bin/core/pickandclick/PickAndClickController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {
    ReelStopPresentationController
} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {
    IndividualWinPresentationController
} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {DWBackground} from "./background/DWBackground";
import {DeadwoodFontConfig} from "./DeadwoodFontConfig";
import {DeadwoodGameAssets} from "./DeadwoodGameAssets";
import {DeadwoodGameConfig} from "./DeadwoodGameConfig";
import {DeadwoodSoundConfig} from "./DeadwoodSoundConfig";
import {BackgroundIdleAnimation} from "./idle/BackgroundIdleAnimation";
import {DeadwoodSymbolIdleAnimation} from "./idle/DeadwoodSymbolIdleAnimation";
import {DustIdleAnimation} from "./idle/DustIdleAnimation";
import {TumbleWeedIdleAnimation} from "./idle/TumbleWeedIdleAnimation";
import {DeadwoodMultiplierController} from "./multiplier/DeadwoodMultiplierController";
import {FireParticles} from "./particles/FireParticles";
import {DeadwoodPickNClickIntroController} from "./picknclick/intro/DeadwoodPickNClickIntroController";
import {DeadwoodPickNClickIntroView} from "./picknclick/intro/DeadwoodPickNClickIntroView";
import {DeadwoodFreespinOutroController} from "./picknclick/outro/DeadwoodFreespinOutroController";
import {DeadwoodFreespinOutroView} from "./picknclick/outro/DeadwoodFreespinOutroView";
import {DeadwoodBonusReelController} from "./reel/DeadwoodBonusReelController";
import {DeadwoodReelAreaView} from "./reel/DeadwoodReelAreaView";
import {DeadwoodReelView} from "./reel/DeadwoodReelView";
import {DeadwoodBonusAttentionController} from "./reelstoppresentation/bonusattention/DeadwoodBonusAttentionController";
import {
    DeadwoodBonusLowSymAttentionController
} from "./reelstoppresentation/bonusattention/DeadwoodBonusLowSymAttentionController";
import {StickyBonusController} from "./reelstoppresentation/bonusattention/StickyBonusController";
import {BonusReelNearWinController} from "./reelstoppresentation/nearwin/BonusReelNearWinController";
import {ScatterReelNearWinController} from "./reelstoppresentation/nearwin/ScatterReelNearWinController";
import {
    DeadwoodScatterAttentionController
} from "./reelstoppresentation/scatterattention/DeadwoodScatterAttentionController";
import {WildAttentionController} from "./reelstoppresentation/wildattention/WildAttentionController";
import {DeadwoodParsedGameData} from "./server/data/DeadwoodParsedGameData";
import {DeadwoodParsedInitData} from "./server/data/DeadwoodParsedInitData";
import {DeadwoodServerDataParser} from "./server/DeadwoodServerDataParser";
import {ShootingGameController} from "./shootinggame/ShootingGameController";
import {DeadwoodBonusSymbol} from "./symbols/DeadwoodBonusSymbol";
import {DeadwoodReelSymbol} from "./symbols/DeadwoodReelSymbol";
import {DeadwoodReelSymbolStateCreator} from "./symbols/DeadwoodReelSymbolStateCreator";
import {DeadwoodScatterSymbol} from "./symbols/DeadwoodScatterSymbol";
import {DeadwoodStackedWild} from "./symbols/DeadwoodStackedWild";
import {DeadwoodBigWinController} from "./winpresentation/bigwin/DeadwoodBigWinController";
import {BonusWinPresentationController} from "./winpresentation/bonuswin/BonusWinPresentationController";
import {DeadwoodIndividualWPController} from "./winpresentation/individual/DeadwoodIndividualWPController";
import {DeadwoodInitialWPController} from "./winpresentation/initial/DeadwoodInitialWPController";
import {DWNoWinPresentationController} from "./winpresentation/nowin/DWNoWinPresentationController";
import {NudgeWildWPController} from "./winpresentation/nudge/NudgeWildWPController";
import {DeadwoodScatterSymbolWPController} from "./winpresentation/scatter/DeadwoodScatterSymbolWPController";
import {DWFreespinZeroBetController} from "./zerobet/DWFreespinZeroBetController";

export class DeadwoodGameModuleConfig implements IGameModuleConfig {

    public static instance:DeadwoodGameModuleConfig = new DeadwoodGameModuleConfig();
    public static backgroundIdle:BackgroundIdleAnimation;
    public static isRestore:boolean=false;
    private static gameTweakerTest:GameTweakerTest;

    GAME_CONFIG:IGameConfig = DeadwoodGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = DeadwoodSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = DeadwoodFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = DeadwoodGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => {
        return new DeadwoodServerDataParser();
    };
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {
        return new DeadwoodParsedInitData(data, <DeadwoodServerDataParser>dataParser);
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {
        return new DeadwoodParsedGameData(data, <DeadwoodServerDataParser>dataParser);
    };

    REEL_AREA_VIEW:() => ReelAreaView = () => {
        return new DeadwoodReelAreaView();
    };

    REEL_CONTROLLER:(reelId:number) => SpinReelController = reelId => {
        if(reelId === 0 || reelId === 4) {
            return new DeadwoodBonusReelController(reelId);
        }
        return new NudgeSpinReelController(reelId);
    };

    REEL_VIEW:(reelId:number) => PIXI.Container = (reelId:number) => {
        return new DeadwoodReelView();
    };

    REEL_PART_ANIMATOR:(reelId:number) => SpinReelPartAnimator = (reelId:number) => {
        if(reelId === 0 || reelId === 4) {
            return new SpinReelPartAnimator(reelId);
        } else {
            return new NudgeSpinReelPartAnimator(reelId);
        }
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig):DeadwoodReelSymbol => {
                if(symName.indexOf("W") > -1) {
                    return new DeadwoodStackedWild(symName, reelId, state, size);
                }
                if(symName === ReelSymbolName.SCATTER) {
                    return new DeadwoodScatterSymbol(symName, reelId, state, size);
                }
                if(symName === "B") {
                    return new DeadwoodBonusSymbol(symName, reelId, state, size);
                }
                return new DeadwoodReelSymbol(symName, reelId, state, size);
            });
    };

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => {
        return new DeadwoodReelSymbolStateCreator();
    };

    PICK_AND_CLICKS:(() => PickAndClickController)[] = [
        () => new DeadwoodPickNClickIntroController({
            viewCreator : (onButtonClickCallback:(index:number, auto:boolean) => void, autoClick?:boolean) => {
                return new DeadwoodPickNClickIntroView({
                    layer : DeadwoodGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    recreateButtons : false
                });
            },
            showWinPresentations : false
        })
    ];

    SCREENS:(() => ScreenController)[] = [
        () => {
            return new DeadwoodFreespinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new DeadwoodFreespinOutroView({
                        layer : DeadwoodGameConfig.instance.LAYERS.FREESPIN_OUTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        mobileScale : 1.2,
                        portraitScale : 1
                    }, autoClose);
                }
            });
        }
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new DWFreespinZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new DeadwoodScatterAttentionController(index),
        index => new DeadwoodBonusAttentionController(index),
        index => new WildAttentionController(index),
        index => new ScatterReelNearWinController(index),
        index => new BonusReelNearWinController(index),
        index => new DeadwoodBonusLowSymAttentionController(index),
        index => new StickyBonusController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new NudgeWildWPController(indexes)],
        [indexes => new BonusWinPresentationController(indexes)],
        [indexes => new DWNoWinPresentationController(indexes)],
        [indexes => new DeadwoodInitialWPController(indexes)],
        [indexes => new DeadwoodBigWinController(indexes)],
        [indexes => new DeadwoodScatterSymbolWPController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new DeadwoodIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        DeadwoodGameModuleConfig.gameTweakerTest = new GameTweakerTest();

        const background = new DWBackground({
            layer : DeadwoodGameConfig.instance.LAYERS.BACKGROUND.name
        });

        const multiplier = new DeadwoodMultiplierController();
        const shootingGame = new ShootingGameController();
        const fireParticles = new FireParticles();
        const symbolIdleAnimation = new DeadwoodSymbolIdleAnimation();
        const tumbleWeed = new TumbleWeedIdleAnimation();
        const dust = new DustIdleAnimation();
        DeadwoodGameModuleConfig.backgroundIdle = new BackgroundIdleAnimation();

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(DeadwoodGameModuleConfig.instance) {
            throw new Error("DeadwoodGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}